module.exports = __webpack_public_path__ + "media/images/arrow_right-4bae46e078af5147d409813239575f62.png";